import { useRef, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import ROUTES from '../../routes';
import api from '../../config/axiosInstance';

import { showToast } from '../../utils/toast';
import { handleErrors } from '../../utils/common';

const AddFaq = () => {
    const formRef = useRef(null);
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        question: '',
        answer: ''
    });

    const [submitting, setSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    useEffect(() => {
        $.validator.addMethod("ckeditorRequired", function (value, element) {
            const textOnly = value.replace(/<[^>]*>/g, '').trim();
            return textOnly.length > 0;
        }, "This field is required");

        if (formRef.current && window.$.fn.validate) {
            window.$(formRef.current).validate({
                ignore: ".ck-editor *",
                rules: {
                    question: {
                        required: true
                    },
                    answer: {
                        required: true,
                        ckeditorRequired: true
                    }
                },
                messages: {
                    question: {
                        required: "Please enter a question",
                        maxlength: "Question cannot exceed 300 characters"
                    },
                    answer: {
                        required: "Please provide an answer",
                        maxlength: "Answer cannot exceed 2000 characters"
                    }
                },
                errorElement: "label",
                validClass: "is-valid",
                errorClass: "is-invalid text-danger",
                highlight: function (element, errorClass, validClass) {
                    $(element).addClass(errorClass).removeClass(validClass);
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).removeClass(errorClass).addClass(validClass);
                }
            });
        }
    }, []);

    const handleFormSubmit = async () => {
        const $ = window.jQuery;
        const form = $(formRef.current);

        if (form.valid()) {
            try {
                setSubmitting(true);
                const res = await api.post("/faq/create", formData);
                showToast("success", res.data.message, "Success");
                navigate(ROUTES.FAQ);
            } catch (err) {
                handleErrors(err);
            } finally {
                setSubmitting(false);
            }
        }
    };

    return (
        <>
            <div className="page-titles">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to={ROUTES.FAQ}>FAQs</Link>
                    </li>
                    <li className="breadcrumb-item active">
                        <Link to={ROUTES.ADD_FAQ}>Add FAQ</Link>
                    </li>
                </ol>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <h4 className="card-title">Add FAQ</h4>
                        </div>
                        <div className="card-body">
                            <form ref={formRef} noValidate>
                                <div className="row">

                                    {[
                                        { name: 'question', label: 'Question' },
                                    ].map(({ name, label }) => (
                                        <div className="mb-3 col-lg-6 col-md-6 col-sm-6" key={name}>
                                            <label className="form-label">
                                                {label}<sup style={{ color: 'red' }}>*</sup>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name={name}
                                                value={formData[name]}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    ))}


                                    {[
                                        { name: 'answer', label: 'Answer' }
                                    ].map(({ name, label }) => (
                                        <div key={name} className="mb-3 col-lg-6 col-md-6 col-sm-6">
                                            <div className="mb-3 col-lg-12">
                                                <label className="form-label">{label}<sup style={{ color: 'red' }}>*</sup></label>
                                                <CKEditor
                                                    editor={ClassicEditor}
                                                    config={{
                                                        toolbar: [
                                                            'heading', '|',
                                                            'bold', 'italic', 'link', 'code', 'codeBlock',
                                                            '|', 'bulletedList', 'numberedList'
                                                        ]
                                                    }}
                                                    data={formData[name]}
                                                    onChange={(event, editor) => {
                                                        const data = editor.getData();
                                                        setFormData(prev => ({ ...prev, [name]: data }));
                                                        document.querySelector(`input[name="${name}"]`).value = data;
                                                    }}
                                                />
                                                <input
                                                    type="hidden"
                                                    name={name}
                                                    value={formData[name]}
                                                />
                                            </div>
                                        </div>
                                    ))}

                                </div>

                                <div className="pt-3">
                                    <button
                                        type="button"
                                        onClick={handleFormSubmit}
                                        className="btn btn-sm btn-primary me-2"
                                        disabled={submitting}
                                    >
                                        {submitting ? (
                                            <>
                                                <i className="spinner-border spinner-border-sm me-1"></i>
                                                Submit
                                            </>
                                        ) : (
                                            <>
                                                <i className="fa fa-floppy-disk me-1"></i>
                                                Submit
                                            </>
                                        )}
                                    </button>
                                    <Link to={ROUTES.FAQ} className="btn btn-sm btn-danger light">
                                        <i className="fas fa-times-circle"></i>&nbsp;
                                        Cancel
                                    </Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddFaq;
